<div>
  <button mat-button (click)="close()" class="buttonClose">Fermer</button>
  <!-- <div [innerHTML]="htmlContent"></div> -->
  <div class="releaseNotes-iFrame">
    <iframe class="releaseNotes-content" [src]="htmlUri"> </iframe>
  </div>
</div>
